


















































































































import {defineComponent, ref, Ref} from "@vue/composition-api"
import ButtonComponent from "@/shared/components/Button.vue"
import {useActions, useGetters} from "vuex-composition-helpers"
import InputAtom from "@/shared/components/atoms/InputAtom.vue"
import axios from 'axios'

export default defineComponent({
    name: "MyStudyChoiceActivationComponent",
    components: {InputAtom, ButtonComponent},
    setup: () => {
        const {toggleModal} = useActions(['toggleModal'])
        const {labels} = useGetters(['labels']);
        const studyChoice: Ref<string> = ref('');
        const canSubmit: Ref<boolean> = ref(false);

        function inputHandler(value: string): void {
            studyChoice.value = value
            canSubmit.value = true
        }

        function submitHandler(): void {
            axios.put(`/api/mystudychoice/mystudychoice/studiekiezerrole/${studyChoice.value}`).then(() => {
                toggleModal()
            }).then(() => {
                window.location.reload()
            }).catch(error => {
                throw error
            })
        }

        function closeHandler(): void {
            toggleModal()
        }

        return {
            labels,
            canSubmit,
            studyChoice,
            inputHandler,
            closeHandler,
            submitHandler
        }
    }
})
